import * as React from "react";
import { MenuItem } from "components/bootstrap";
import useInvestigationPanel from "security-app/components/Investigations/hooks/useInvestigationPanel";
import { useAddEvidence, useGetInvestigationDetails } from "security-app/hooks/useInvestigationsAPI";
import useActionCondition from "security-app/components/Investigations/plugin/useActionCondition";
import AddEvidenceModal from "./shared/AddEvidenceModal";
export const EventsInvestigationsModal = React.forwardRef(
  ({ eventId }, ref) => {
    const isAvailable = useActionCondition();
    if (!isAvailable) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(AddEvidenceModal, { ids: [eventId], type: "events", ref });
  }
);
const CoreEventWidgetActions = ({ eventId, modalRef }) => {
  const { selectedInvestigationId, expandPanel } = useInvestigationPanel();
  const { currentInvestigation } = useGetInvestigationDetails(selectedInvestigationId);
  const { addEvidence } = useAddEvidence();
  const disabledAdd = !currentInvestigation || (currentInvestigation == null ? void 0 : currentInvestigation.archived);
  const onAddEvent = async () => {
    if (disabledAdd) return;
    await addEvidence({
      invId: selectedInvestigationId,
      payload: { events: [eventId] }
    });
    expandPanel();
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { disabled: disabledAdd, onClick: onAddEvent, icon: "extension" }, "Add to investigation"), /* @__PURE__ */ React.createElement(MenuItem, { icon: "extension", onClick: () => {
    var _a;
    return (_a = modalRef()) == null ? void 0 : _a.toggle();
  } }, "Select an investigation"));
};
export default CoreEventWidgetActions;
